import { Toggler as GammaToggler } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

type TogglerProps = React.ComponentProps<typeof GammaToggler>

type Props = Omit<TogglerProps, 'ariaLabel'> & {
  ariaLabel?: string
}

const Toggler: React.FC<Props> = ({ ariaLabel, ...props }) => (
  <GammaToggler {...props} ariaLabel={ariaLabel ?? i18n.t('common.toggle')} />
)

export default Toggler
